import CheckResultRuntime from 'packages/helpers/CheckResultRuntime';
import {ResultWithError} from 'packages/errors/errors';
import {post} from 'packages/rest/api';
import {SessionRaw, SessionRuntime} from '../model';

export async function VerifyRequestedEmailAPI(code: string, isTourOperator?: boolean): Promise<ResultWithError<SessionRaw>> {
    const res = await post({url: 'session/emails/verifications', body: {code, is_tour_operator: isTourOperator}});
    return CheckResultRuntime(SessionRuntime, res);
}
